import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotfallrufnummernPopup } from '../popups/NotfallrufnummernPopup'
import { eGENA_Teilnehmerspezifisches } from '../../visionet/Teilnehmerspezifisches';
import { KlinikkennungEingabePopup } from '../popups/KlinikkennungEingabePopup';
import { HaftungsausschlussPopup } from '../popups/HaftungsausschlussPopup';
import { ImpressumPage } from '../../pages/Impressum/Impressum';
import { DatenschutzPage } from '../../pages/Datenschutz/Datenschutz';
import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';



@Component({
	selector: 'Rechtliches',
	templateUrl: 'Rechtliches.html'
})
export class RechtlichesComponent {

	/**	=== Visionet(sl) ==========
	 *	Beim Aufruf des Konstruktors ist der Eingangs-Parameter `notfallrufnummern` noch undefiniert.
	 *	Wir brauchen den Konstruktor nur um den `DomSanitizer` und en `PopoverController` zu erhalten.
	 */
	constructor(public navCtrl: NavController, public sanitizer: DomSanitizer, public popoverCtrl: PopoverController, public globals: GlobalsSingleton) {
	}


	/**	=== Visionet(sl) ==========
	 *	Zur Impressums-Seite
	 */
	goImpressum(event : UIEvent) : void {
		this.navCtrl.push(ImpressumPage, {
		},
		{
			animate : true,
			animation: "ios-transition"
		});
	}


	/**	=== Visionet(sl) ==========
	 *	Zur Datenschutz-Seite
	 */
	goDatenschutz(event : UIEvent) : void {
		this.navCtrl.push(DatenschutzPage, {
		},
		{
			animate : true,
			animation: "ios-transition"
		});
	}


	/**	=== Visionet(sl) ==========
	 *	Zur Datenschutz-Seite
	 */
	goHaftungsausschluss(event : UIEvent) : void {
		let popover = this.popoverCtrl.create(
			HaftungsausschlussPopup,
			// data
			{ "showCheckbox": false },
			//PopoverOptions
			{ cssClass: "haftungsausschluss",
				showBackdrop: true,
				enableBackdropDismiss: true
			}
		);
		popover.present({
		});
	}

}



// WEBPACK FOOTER //
// ./src/components/Rechtliches/Rechtliches.ts